// Vendors
import React from 'react';
// Constants
import { WRAPPED_STATES } from './constants/contract-wrapper.constants';
// Styles
import { LayoutContentStyled } from 'styles/app.styled';
// Types
import { ContractWrapperType } from './types/contract-wrapper.types';

const ContractWrapper = ({ children, contractState }: ContractWrapperType): React.JSX.Element =>
  WRAPPED_STATES.includes(contractState) ? (
    <LayoutContentStyled>{children}</LayoutContentStyled>
  ) : (
    children
  );

export { ContractWrapper };
